module.exports = __webpack_public_path__ + "img/d-WA-vote-share-icon.298c056a.svg";